export default "__VITE_ASSET__fda0b0ca__"